export enum UserAddressFields {
    Id = 'id',
    Street = 'calle',
    StreetNumber = 'calleNro',
    FloorApartment = 'deptoPiso',
    Neighborhood = 'barrio',
    ZipCode = 'codigoPostal',
    ProvinceId = 'codProvincia',
    CityId = 'codLocalidad',
    CountryId = 'codPais',
    CountryISO = 'ISOPais',
    ProvinceDesc = 'descProvincia',
    CityDesc = 'descLocalidad',
    CountryDesc = 'descPais',
    Selected = 'seleccionado',
}


export interface UserAddress {
    [UserAddressFields.Id]: number;
    [UserAddressFields.Street]: string;
    [UserAddressFields.StreetNumber]: string;
    [UserAddressFields.FloorApartment]?: string | null;
    [UserAddressFields.Neighborhood]?: string | null;
    [UserAddressFields.ZipCode]: string;
    [UserAddressFields.ProvinceId]: number;
    [UserAddressFields.CityId]: number;
    [UserAddressFields.CountryId]: number;
    [UserAddressFields.CountryISO]: string;
    [UserAddressFields.ProvinceDesc]: string;
    [UserAddressFields.CityDesc]: string;
    [UserAddressFields.CountryDesc]: string;
    [UserAddressFields.Selected]: boolean;
}


export enum UserAddressCreateUpdateFields {
    Street = "calle",
    StreetNumber = 'calleNro',
    FloorApartment = "deptoPiso",
    Neighborhood = "barrio",
    ZipCode = "codigoPostal",
    ProvinceId = "codProvincia",
    CityId = "codLocalidad",
    CountryId = "codPais",
}

export interface UserAddressCreateUpdateDTO {
    [UserAddressCreateUpdateFields.Street]: string;
    [UserAddressCreateUpdateFields.StreetNumber]: string;
    [UserAddressCreateUpdateFields.FloorApartment]?: string | null;
    [UserAddressCreateUpdateFields.Neighborhood]?: string | null;
    [UserAddressCreateUpdateFields.ZipCode]: string;
    [UserAddressCreateUpdateFields.ProvinceId]: number;
    [UserAddressCreateUpdateFields.CityId]: number;
    [UserAddressCreateUpdateFields.CountryId]?: number;
}














